import React from "react";
import isAuthenticated from "global/utils/isAuthenticated";
import WhatsAppFloatingButton from "../WhatsAppFloatingButton/WhatsAppFloatingButton";
import { useWebChat } from "./WebChatProvider";
import { ChatBubbleIcon, CloseIcon, UnreadBadge } from "./WebChatIcons";
import "./WebChatFloatingButton.css";

/**
 * Boton flotante del portal logueado. Reemplaza al de WhatsApp cuando config.json
 * trae "webchat"; si no, cae al boton de WhatsApp de siempre.
 * Misma regla de visibilidad que el de WhatsApp: solo logueado y solo desktop (>= 1280px).
 */
const WebChatFloatingButton = () => {
  const { enabled, open, unread, toggleChat } = useWebChat();

  if (!isAuthenticated()) return null;
  if (!enabled) return <WhatsAppFloatingButton />;

  return (
    <button
      type="button"
      className={`webchat-fab${open ? " is-open" : ""}`}
      onClick={toggleChat}
      aria-label={open ? "Cerrar chat de ayuda" : "Abrir chat de ayuda"}
      aria-expanded={open}
    >
      {open ? <CloseIcon /> : <ChatBubbleIcon />}
      {!open && <UnreadBadge count={unread} className="webchat-fab-badge" />}
    </button>
  );
};

export default WebChatFloatingButton;
